import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { interval, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BadgeModalComponent } from '../../shared/badge-modal/badge-modal.component';
import { OeAppService } from '../../shared/oe-app.service';
import { TranslationService } from '../../shared/translation.service';
import { GamificationBadgeDto } from '../../shared/types/GamificationBadgeDto';
import { GamificationLeaderboardDto } from '../../shared/types/GamificationLeaderboardDto';
import { GamificationLeagueDto } from '../../shared/types/GamificationLeagueDto';
import { GamificationProfileDto } from '../../shared/types/GamificationProfileDto';
import { GamificationSettingsDto } from '../../shared/types/GamificationSettingsDto';
import { UtilsService } from '../../shared/utils.service';

@Component({
  selector: 'lp2-leaderboard-active',
  templateUrl: './leaderboard-active.component.html',
  styleUrls: ['./leaderboard-active.component.scss'],
})
export class LeaderboardActiveComponent implements OnInit, OnDestroy {
  @Input()
  set leaguesData(data: GamificationLeagueDto[]) {
    this.leagues = data;
    this.initLeagueData();
  }

  @Input()
  set leaderboard(data: GamificationLeaderboardDto) {
    this.leaderboardData = data;
    setTimeout(() => {
      if (this.memberDivs.length) {
        const element = this.memberDivs.toArray()[
          this.leaderboardData.members.findIndex((e) => !!e.currentUser)
        ].nativeElement;
        element.parentElement.scrollTop =
          element.offsetTop - element.parentElement.offsetTop;
      }
    });
  }

  @Input()
  set gamificationProfileData(data: GamificationProfileDto) {
    this.gamificationProfile = data;
    this.initLeagueData();
  }

  @Input()
  set activityBadgeData(data: GamificationBadgeDto) {
    this.activityBadge = data;
    if (data) {
      this.remainingTime = data.remainingTimeMilliseconds;
      if (this.remainingTime < 1) {
        this.remainingTime = 1;
      }
      this.refreshRemainingTime();
    }
  }

  @Input()
  set gamificationSettings(data: GamificationSettingsDto) {
    if (data) {
      this.topQualify = data.promotionZoneIndex;
      this.bottomDemotion = data.demotionZoneIndex;
    }
  }

  @Output()
  reloadLeaderboard = new EventEmitter();

  @ViewChildren('memberDivs')
  memberDivs: QueryList<ElementRef>;

  topQualify = 10;

  bottomDemotion = 40;

  modalRef: NgbModalRef;

  leaderboardData: GamificationLeaderboardDto;

  leagues: GamificationLeagueDto[];

  activityBadge: GamificationBadgeDto;

  gamificationS3Url = `//${this.oeApp.s3BucketHost()}/gamification`;

  remainingTime: number;

  gamificationProfile: GamificationProfileDto;

  currentLeagueIndex: number;

  remaining: { days: number; hours: number; minutes: number };

  timerSubscription: Subscription;

  currentLanguage: string;

  constructor(
    private oeApp: OeAppService,
    private modalService: NgbModal,
    private translationService: TranslationService
  ) {}

  ngOnInit() {
    this.currentLanguage = this.translationService.getCurrentLanguage();

    this.timerSubscription = interval(1000)
      .pipe(filter(() => this.remainingTime > 0))
      .subscribe(() => {
        if (this.remainingTime === undefined) {
          return;
        }

        this.remainingTime -= 1000;
        if (this.remainingTime > 0) {
          this.refreshRemainingTime();
        } else {
          setTimeout(() => this.reloadLeaderboard.emit(), 5000);
        }
      });
  }

  trackByLeague(index: number, item: GamificationLeagueDto) {
    return item.id;
  }

  refreshRemainingTime() {
    if (this.remainingTime > 0) {
      this.remaining = UtilsService.remainingTime(this.remainingTime);
    }
  }

  initLeagueData() {
    if (this.gamificationProfile && this.leagues) {
      this.currentLeagueIndex = this.leagues.findIndex(
        (e: GamificationLeagueDto) => e.id === this.gamificationProfile.leagueId
      );
    }
  }

  selectBadge() {
    this.modalRef = this.modalService.open(BadgeModalComponent, {
      size: 'lg',
    });
    this.modalRef.componentInstance.badge = this.activityBadge;
    this.modalRef.componentInstance.topQualify = this.topQualify;
  }

  ngOnDestroy() {
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/leaderboard-active/leaderboard-active.component.ts